import {styled} from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";

export default styled(Drawer)(({ theme, ownerState }) => {
  const { palette, boxShadows, transitions, breakpoints, functions } = theme;
  const { transparentSidenav, whiteSidenav, miniSidenav, darkMode } = ownerState;

  const sidebarWidth = 280;
  const { transparent, gradients, white, background } = palette;
  const { xxl } = boxShadows;
  const { pxToRem, linearGradient } = functions;

  let backgroundValue = darkMode
      ? "rgba(18, 18, 22, 0.96)"
      : linearGradient(gradients.dark.main, gradients.dark.state);

  if (transparentSidenav) {
    backgroundValue = "rgba(255,255,255,0.08)";
  } else if (whiteSidenav) {
    backgroundValue = "rgba(255,255,255,0.96)";
  }

  const drawerBase = {
    background: backgroundValue,
    backdropFilter: "blur(18px)",
    borderRight: darkMode
        ? "1px solid rgba(255,255,255,0.08)"
        : "1px solid rgba(0,0,0,0.06)",
    boxShadow: transparentSidenav ? "none" : xxl,
    overflowX: "hidden",
  };

  const drawerOpenStyles = () => ({
    ...drawerBase,
    width: sidebarWidth,
    transform: "translateX(0)",
    transition: transitions.create(["width", "transform", "background-color"], {
      easing: transitions.easing.sharp,
      duration: transitions.duration.enteringScreen,
    }),

    [breakpoints.up("xl")]: {
      width: sidebarWidth,
      transform: "translateX(0)",
    },
  });

  const drawerCloseStyles = () => ({
    ...drawerBase,
    transform: `translateX(${pxToRem(-320)})`,
    transition: transitions.create(["width", "transform"], {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      width: pxToRem(96),
      transform: "translateX(0)",
    },
  });

  return {
    "& .MuiDrawer-paper": {
      border: "none",
      borderRadius: "0 24px 24px 0",
      margin: "12px 0 12px 12px",
      height: "calc(100vh - 24px)",

      ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
    },
  };
});